import {
    ArrowLongLeftIcon,
    ArrowLongRightIcon
} from '@heroicons/react/20/solid'
import { Dispatch, SetStateAction } from 'react'

function getPageList(totalPages: number, page: number, maxLength: number) {
    function range(start: number, end: number) {
        return Array.from(Array(end - start + 1), (_, i) => i + start)
    }

    const sideWidth = maxLength < 9 ? 1 : 2
    const leftWidth = (maxLength - sideWidth * 2 - 3) >> 1
    const rightWidth = (maxLength - sideWidth * 2 - 2) >> 1
    if (totalPages <= maxLength) {
        return range(1, totalPages)
    }

    if (page <= maxLength - sideWidth - 1 - rightWidth) {
        // no break on left of page
        return range(1, maxLength - sideWidth - 1).concat(
            0,
            range(totalPages - sideWidth + 1, totalPages)
        )
    }

    if (page >= totalPages - sideWidth - 1 - rightWidth) {
        // no break on right of page
        return range(1, sideWidth).concat(
            0,
            range(
                totalPages - sideWidth - 1 - rightWidth - leftWidth,
                totalPages
            )
        )
    }
    // Breaks on both sides
    return range(1, sideWidth).concat(
        0,
        range(page - leftWidth, page + rightWidth),
        0,
        range(totalPages - sideWidth + 1, totalPages)
    )
}

export default function Pagination({
    handleClick,
    currentPage,
    pages
}: {
    handleClick: (page: number) => void
    currentPage: number
    pages: number
}) {
    const pagesArray = getPageList(pages, currentPage, 20)

    return (
        <nav className="my-10 flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
            <div className="-mt-px flex w-0 flex-1">
                <button
                    disabled={currentPage == 1}
                    onClick={() => handleClick(currentPage - 1)}
                    className="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                >
                    <ArrowLongLeftIcon
                        aria-hidden="true"
                        className="mr-3 h-5 w-5 text-gray-400"
                    />
                    Previous
                </button>
            </div>
            <div className="hidden md:-mt-px md:flex">
                {pagesArray.map((page, index) =>
                    page == 0 ? (
                        <span
                            key={index}
                            className={`inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700`}
                        >
                            ...
                        </span>
                    ) : (
                        <button
                            onClick={() => handleClick(page)}
                            key={index}
                            className={`inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 ${
                                currentPage == page
                                    ? 'border-blue-500'
                                    : 'border-transparent'
                            }`}
                        >
                            {page}
                        </button>
                    )
                )}
                {/* Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" */}
            </div>
            <div className="-mt-px flex w-0 flex-1 justify-end">
                <button
                    disabled={pages == currentPage}
                    onClick={() => handleClick(currentPage + 1)}
                    className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                >
                    Next
                    <ArrowLongRightIcon
                        aria-hidden="true"
                        className="ml-3 h-5 w-5 text-gray-400"
                    />
                </button>
            </div>
        </nav>
    )
}
